import { render, staticRenderFns } from "./ReleasePlay.vue?vue&type=template&id=f9494bea&scoped=true"
import script from "./ReleasePlay.vue?vue&type=script&lang=js"
export * from "./ReleasePlay.vue?vue&type=script&lang=js"
import style0 from "./ReleasePlay.vue?vue&type=style&index=0&id=f9494bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9494bea",
  null
  
)

export default component.exports